export default __webpack_public_path__ + "static/media/books-480w.5d42544f.png";